import { PRIMARY_COLOR } from '../../config/color';

export const ServiceAiSVG = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.51005 14.6035C3.38077 14.6035 3.26001 14.5538 3.16908 14.4628C3.07957 14.3733 3.02843 14.2497 3.02843 14.1219V10.7689C3.02843 10.742 3.00854 10.7192 2.98154 10.715C2.42604 10.6425 1.44147 10.4351 1.08202 9.85258C0.905853 9.56701 0.890225 9.22461 1.03798 8.89074C1.42442 8.02125 2.06801 7.39329 2.41609 7.09778C2.42604 7.08925 2.43314 7.07647 2.43456 7.06368C2.56101 6.0507 3.44754 1 8.52523 1C11.29 1 13.5248 2.25166 14.5037 4.34582C15.5465 6.58063 14.9342 9.35248 12.8229 11.9524C12.8144 11.9624 12.8116 11.9737 12.8116 11.9865V14.0395C12.8116 14.3051 12.5956 14.5211 12.33 14.5211C12.0643 14.5211 11.8483 14.3051 11.8483 14.0395V11.7919C11.8483 11.6782 11.8881 11.5688 11.9606 11.4822C13.924 9.13653 14.5335 6.6815 13.6328 4.75073C12.8158 3.00323 10.9078 1.96041 8.52666 1.96041C3.75016 1.96041 3.38645 7.1404 3.37224 7.36061C3.3623 7.50411 3.29126 7.63624 3.17476 7.72148C3.08526 7.78967 2.31238 8.39349 1.91883 9.28002C1.91315 9.29423 1.91315 9.30986 1.91883 9.32264C2.01971 9.56133 2.85083 9.76449 3.53279 9.79859C3.78994 9.81137 3.99026 10.0216 3.99168 10.2788V13.5848C3.99168 13.6147 4.01583 13.6388 4.04567 13.6388H6.73511C7.00079 13.6388 7.21674 13.8548 7.21674 14.1205C7.21674 14.3861 7.00079 14.6021 6.73511 14.6021H3.51005V14.6035Z"
        fill="#0E45B0"
        stroke={PRIMARY_COLOR}
        stroke-width="0.2"
      />
      <path
        d="M9.02151 10.308C8.81834 10.308 8.63649 10.1801 8.5683 9.98975L8.26568 9.10463C8.25858 9.08332 8.23726 9.06769 8.21453 9.06769H6.62474C6.602 9.06769 6.58069 9.0819 6.57359 9.10321L6.2525 9.99685C6.18005 10.1787 6.00388 10.2966 5.80639 10.2966C5.75099 10.2966 5.69558 10.2867 5.64301 10.2682C5.39864 10.1801 5.26794 9.91729 5.3475 9.66866L6.99981 5.07117C7.068 4.8808 7.24986 4.75293 7.45302 4.75293C7.66045 4.75435 7.8423 4.88506 7.90766 5.07828L9.4804 9.67718C9.56139 9.92439 9.425 10.1972 9.17779 10.281C9.12664 10.2995 9.0755 10.308 9.02151 10.308ZM7.43881 6.79878C7.41608 6.79878 7.39477 6.81299 7.38767 6.8343L6.95861 8.03056C6.95292 8.04761 6.95577 8.06608 6.96571 8.08028C6.97566 8.09449 6.9927 8.10301 7.00975 8.10301H7.84798C7.86503 8.10301 7.88208 8.09449 7.89203 8.08028C7.90197 8.06608 7.90481 8.04761 7.89913 8.03056L7.48996 6.8343C7.48286 6.81299 7.46297 6.79878 7.43881 6.79878ZM10.6355 10.2725C10.3698 10.2725 10.1538 10.0636 10.1538 9.80789V5.22177C10.1538 4.96604 10.3698 4.75719 10.6355 4.75719C10.9011 4.75719 11.1171 4.96604 11.1171 5.22177V9.80931C11.1157 10.065 10.8997 10.2725 10.6355 10.2725Z"
        fill="#0E45B0"
      />
    </svg>
  );
};

export const ServiceDataSVG = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 11H2V15H5V11Z" stroke="#0E45B0" stroke-width="1.5" />
      <path d="M0 15H15" stroke="#0E45B0" stroke-width="1.5" />
      <path d="M9 6H5V15H9V6Z" stroke="#0E45B0" stroke-width="1.5" />
      <path d="M14 3H9V15H14V3Z" stroke="#0E45B0" stroke-width="1.5" />
    </svg>
  );
};
export const ServiceQuotaSVG = () => {
  return (
    <svg viewBox="0 0 140 125" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M140 0V50.689C140 80.8727 126.591 105.643 99.7719 125L82.691 105.151C92.2691 96.1833 98.3884 89.6216 101.049 85.4659C105.625 78.4668 107.913 70.1006 107.913 60.3675V55.4462H84.7662V0H140ZM57.309 0V50.689C57.309 80.8727 43.8997 105.643 17.081 125L0 105.151C9.57811 96.1833 15.6974 89.6216 18.358 85.4659C22.9342 78.4668 25.2223 70.1006 25.2223 60.3675V55.4462H2.07526V0H57.309Z"
        fill={PRIMARY_COLOR}
      />
    </svg>
  );
};

export const ServiceWhySVG = () => {
  return (
    <svg viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33 5.5H8C6.61929 5.5 5.5 6.61929 5.5 8V33C5.5 34.3807 6.61929 35.5 8 35.5H33C34.3807 35.5 35.5 34.3807 35.5 33V8C35.5 6.61929 34.3807 5.5 33 5.5Z"
        stroke="#3309CD"
        stroke-width="2"
      />
      <path
        d="M20.5 24.3542V21.0209C23.2614 21.0209 25.5 18.7823 25.5 16.0209C25.5 13.2595 23.2614 11.0209 20.5 11.0209C17.7386 11.0209 15.5 13.2595 15.5 16.0209"
        stroke="#3309CD"
        stroke-width="2"
        stroke-linecap="square"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.4974 31.8542C21.648 31.8542 22.5807 30.9214 22.5807 29.7708C22.5807 28.6202 21.648 27.6875 20.4974 27.6875C19.3468 27.6875 18.4141 28.6202 18.4141 29.7708C18.4141 30.9214 19.3468 31.8542 20.4974 31.8542Z"
        fill="#3309CD"
      />
    </svg>
  );
};

export const ServiceWhatSVG = () => {
  return (
    <svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.8307 8.33337V3.33337H7.16406V31.6667L11.3516 29.7144"
        stroke="#FF8301"
        stroke-width="1.8"
        stroke-linecap="square"
      />
      <path
        d="M12.1641 36.6667V8.33337H33.8307V36.6667L22.9974 31.4395L12.1641 36.6667Z"
        stroke="#FF8301"
        stroke-width="1.8"
      />
    </svg>
  );
};

export const ServiceHowSVG = () => {
  return (
    <svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.8307 16.6667C33.8307 22.3398 30.2877 27.1854 25.2936 29.1114H20.4974H15.7011C10.7071 27.1854 7.16406 22.3398 7.16406 16.6667C7.16406 9.30287 13.1336 3.33337 20.4974 3.33337C27.8612 3.33337 33.8307 9.30287 33.8307 16.6667Z"
        stroke={PRIMARY_COLOR}
        stroke-width="1.8"
        stroke-linecap="square"
      />
      <path
        d="M25.2957 29.1113L24.7298 35.9026C24.6938 36.3345 24.3327 36.6667 23.8993 36.6667H17.0995C16.6661 36.6667 16.305 36.3345 16.2691 35.9026L15.7031 29.1113"
        stroke={PRIMARY_COLOR}
        stroke-width="1.8"
        stroke-linecap="square"
      />
      <path
        d="M15.5 14.1666V19.1666L20.5 16.6666L25.5 19.1666V14.1666"
        stroke={PRIMARY_COLOR}
        stroke-width="1.8"
        stroke-linecap="square"
      />
    </svg>
  );
};
